import React, { useState } from "react";
import IntlMessages from "../util/IntlMessages";
import { Button, Col, Modal, Row, Table } from "antd";
import { PartialStockModalType } from "../constants/PartialStockModalType";

import { PartialStockUpdateEnums } from "../constants/PartialStockUpdateEnums";
import { formatDigits } from "../appRedux/actions";
import { useSelector } from "react-redux";
 
const AutoStockOrderModal = (props) => {
  const {
    productStockData,
    isModalActive,
    setIsStockOrderModalActive,
    setPartialStockUpdate,
    modalType,
  } = props;

  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  );
  const columns = [
    {
      title: <IntlMessages id="components.autostockordermodal.products" />,
      dataIndex: "ProductName",
      key: "ProductName",
      render: (text, record) => {
        return <p>{text}</p>;
      },
    },
    {
      title: (
        <IntlMessages id="components.autostockordermodal.quantitynotrcv" />
      ),
      dataIndex: "Quantity",
      key: "Quantity",
      render: (text, record) => {
        return <p>{text}</p>;
      },
    },
    {
      title: <IntlMessages id="components.autostockordermodal.totalcost" />,
      dataIndex: "TotalCost",
      key: "TotalCost",
      render: (text, record) => {
        return <p>{formatDigits(text,getDefaultDecimalPlaces) }</p>;
      },
    },
  ];

  const onClickCreateNewOrder = (partialUpdateEnum) => {
    setIsStockOrderModalActive(false);
    setPartialStockUpdate(partialUpdateEnum);
  };
  return (
    <Modal
      transitionName=""
      maskTransitionName=""
      className="fullfillment-modal"
      visible={isModalActive}
      okText={<IntlMessages id="common.resource.save" />}
      width={400}
      centered={true}
      footer={
        <div>
          <Button
            type="primary"
            className="dk-btn-expand-cancel"
            onClick={() =>
              onClickCreateNewOrder(PartialStockUpdateEnums.NoUpdate)
            }
          >
            {modalType == PartialStockModalType.TransferStockModal ? (
              <IntlMessages id="components.autostockordermodal.dontcreatenewtransfer" />
            ) : (
              <IntlMessages id="components.autostockordermodal.dontcreatenew" />
            )}
          </Button>

          <Button
            type="primary"
            className="dk-btn-add"
            onClick={() =>
              onClickCreateNewOrder(PartialStockUpdateEnums.UpdatePartialStock)
            }
          >
            {modalType == PartialStockModalType.TransferStockModal ? (
              <IntlMessages id="components.autostockordermodal.createnewordertransfer" />
            ) : (
              <IntlMessages id="components.autostockordermodal.createneworder" />
            )}
          </Button>
        </div>
      }
    >
      <Row className="custom-mg-bt">
        <Col md={24}>
          <div>
            <h1 className="dk-quick-modal-header">
              {modalType == PartialStockModalType.TransferStockModal ? (
                <IntlMessages id="components.autostockordermodal.theseorderedproductstransfer" />
              ) : (
                <IntlMessages id="components.autostockordermodal.theseorderedproducts" />
              )}
            </h1>
            <p className="">
              {modalType == PartialStockModalType.TransferStockModal ? (
                <IntlMessages id="components.autostockordermodal.ifyouexpecttransfer" />
              ) : (
                <IntlMessages id="components.autostockordermodal.ifyouexpect" />
              )}
            </p>
          </div>
        </Col>
      </Row>
      <Table
        className="gx-table-responsive"
        columns={columns}
        dataSource={productStockData}
        pagination={false}
      />
    </Modal>
  );
};

export default AutoStockOrderModal;
